import { createBrowserRouter } from "react-router-dom";
import Main from "../../layouts/Main";
import Category from "../../Pages/Category/Category/Category";
import Home from "../../Pages/Home/Home/Home";
import Login from "../../Pages/Login/Login/Login";
import Register from "../../Pages/Login/Register/Register";
import News from "../../Pages/News/News/News";
import Profile from "../../Pages/Others/Profile/Profile";
import TermsAndConditions from "../../Pages/Others/TermsAndConditions/TermsAndConditions";
import PrivateRoute from "../PrivateRoute/PrivateRoute";

export const routes = createBrowserRouter([
   {
      path: "/",
      element: <Main />,
      children: [
         {
            path: "/",
            element: <Home />,
            loader: () => fetch("https://world-news-server.vercel.app/news"),
         },
         {
            path: "/category/:id",
            element: <Category />,
            loader: ({ params }) =>
               fetch(`https://world-news-server.vercel.app/category/${params.id}`),
         },
         {
            path: "/news/:id",
            element: (
               <PrivateRoute>
                  <News />
               </PrivateRoute>
            ),
            loader: ({ params }) => fetch(`https://world-news-server.vercel.app/news/${params.id}`),
         },
         {
            path: "/login",
            element: <Login />,
         },
         {
            path: "/register",
            element: <Register />,
         },
         {
            path: "/terms",
            element: <TermsAndConditions />,
         },
         {
            path: "/profile",
            element: (
               <PrivateRoute>
                  <Profile />
               </PrivateRoute>
            ),
         },
      ],
   },
]);
